import { Injectable } from '@angular/core';
import { SocialLoginComponent } from './social.login.component';

@Injectable({
  providedIn: 'root'
})
export class CheckLoginStatusService {

  isUserLoggedIn = localStorage.getItem('social.login.googleUser') || localStorage.getItem('social.login.facebookUser') ? true : false;
  profilePicture?: string = JSON.parse(localStorage.getItem('social.login.googleUser') || localStorage.getItem('social.login.facebookUser'))?.profilePicture || '';
  provider?: string = localStorage.getItem('social.login.googleUser') ? 'google': localStorage.getItem('social.login.facebookUser') ? 'facebook' : '';

  checkGoogleLoginStatus(): boolean {
    const stored = localStorage.getItem('social.login.googleUser');
    if (stored) {
      const user = JSON.parse(stored);
      this.isUserLoggedIn  = true;
      this.profilePicture  = user.profilePicture;
      this.provider = 'google';
      SocialLoginComponent.loginStatus$.next(true);
    }
    return this.isUserLoggedIn;
  }

  checkFacebookLoginStatus(): boolean {
    const stored = localStorage.getItem('social.login.facebookUser');
    if (stored) {
      const user = JSON.parse(stored);
      this.isUserLoggedIn  = true;
      this.profilePicture  = user.profilePicture;
      this.provider = 'facebook';
      SocialLoginComponent.loginStatus$.next(true);
    }
    return this.isUserLoggedIn;
  }

}
